import {IComponentController, IComponentOptions} from "angular";
import './order-toggle.component.scss';
import {Sorting, SortingDirection} from "./sorting";


export class OrderToggleComponent implements IComponentController {

    public static instance: IComponentOptions = {
        template: require('./order-toggle.component.html'),
        controller: [OrderToggleComponent],
        bindings: {
            'order': '=',
            'onOrderChange': '<'
        }
    };

    private allDirections = Object.values(SortingDirection);
    private position: number;
    private onOrderChange: () => void;
    private order: Sorting;

    $onInit = (): void => {
        this.order.value = this.order.value ? this.order.value : SortingDirection.NONE;
        this.getStartingPosition();
        this.updateOrderDirection();
    };

    private updateOrder = () => {
        this.position += 1;
        this.order.lastUpdated = new Date(Date.now());
        this.updateOrderDirection();
        this.onOrderChange();
    };

    private updateOrderDirection = () => {
        if (this.position >= this.allDirections.length) {
            this.position = 0;
        }
        this.order.value = this.allDirections[this.position];
    };

    private getStartingPosition = () => {
        this.position = Object.values(SortingDirection)
            .findIndex(dir => dir == this.order.value)
    };


}